<template>
    <ValidationObserver ref="form" v-slot="{ invalid }">
        <div class="absolute top-0 left-0 right-0 bottom-0 w-full overflow-hidden flex items-center text-center justify-center z-50" v-show="loading"><spinner line-fg-color="#922C49" size="55" :line-size="5"></spinner></div>
        <form id="form" v-if="!loading" @submit.prevent="submitForm" class="flex flex-col h-full">
            <page-header :buttons="pageActions.buttons" :additional="pageActions.additional" @method="methodHandler">
                <template slot="title">{{ type }} Permission</template>
            </page-header>

            <tabs :tabs="tabs" :active="startTab" @setTab="setActiveTab" ref="tabs"></tabs>
            <div class="bg-red-200 py-2 text-sm text-red-700 text-center w-full -mt-px" role="alert" v-show="invalid && submitted" >Please complete all required fields</div>
            <div class="bg-red-200 py-2 text-sm text-red-700 text-center w-full -mt-px" v-if="errorMessage">{{ errorMessage }}</div>

            <div class="flex md:flex-row sm:flex-col flex-grow">
                <div class="md:w-3/4 sm:w-full px-4 sm:px-6 lg:px-6 bg-gray-200 border-r border-gray-400" v-show="activeTab === 'details'">
                    <ValidationObserver vid="details" :slim="true">
                        <div class="mt-6 grid grid-cols-1 row-gap-5 col-gap-4 sm:grid-cols-12">
                            <input-text class="sm:col-span-4"
                                label="Name"
                                placeholder="Name"
                                name="name"
                                v-model="item.name"
                                rules="required"
                                :required="true" />
                            <input-text class="sm:col-span-4"
                                label="Route"
                                placeholder="Route"
                                name="route"
                                v-model="item.route"
                                rules="required"
                                :required="true" />
                            <input-select class="sm:col-span-4"
                                label="Type"
                                placeholder="Type"
                                name="type"
                                v-model="item.type_id"
                                :initialValue="initialValue.type"
                                return="value"
                                rules="required"
                                :required="true"
                                :options="options.types"/>
                            <input-textarea class="sm:col-span-12"
                                label="Description"
                                placeholder="Description"
                                name="description"
                                v-model="item.description"
                                :required="false" />
                        </div>
                    </ValidationObserver>
                </div>
                <div class="md:w-1/4 sm:w-full px-4 sm:px-6 lg:px-6">
                    <ValidationObserver vid="details" :slim="true">
                        <div class="mt-6 grid grid-cols-1 row-gap-5 col-gap-4 sm:grid-cols-12">
                            <input-toggle class="sm:col-span-6"
                                label="Active"
                                name="active"
                                v-model="item.active"
                                :required="false" />
                            <input-toggle class="sm:col-span-6"
                                label="Hidden"
                                name="hidden"
                                v-model="item.hidden"
                                :required="false" />
                        </div>
                    </ValidationObserver>
                </div>
            </div>
        </form>
        <transition name="fade">
            <delete-confirmation-modal v-if="showDeleteModal" @close="closeDeleteModal" @delete="deleteItem" ref="datatableDeleteModal">
                <template slot="content">Are you sure you want to delete the <strong>{{ item.name }}</strong> Permission?</template>
            </delete-confirmation-modal>
        </transition>
    </ValidationObserver>
</template>

<script>
    import axios from "axios";
    import FormSetup from "../../../mixins/Tabs";
    import FormButtons from "../../../mixins/FormButtons";
    import DeleteModal from "../../../mixins/DeleteModal";

    export default {
        name: "PermissionForm",
        props: {
            id: {required: false},
            type: {required: true},
            return: {required: false, default: '/configuration/permissions'},
            page: {required: false, default: 'permissions'}
        },
        mixins: [
            FormSetup,
            FormButtons,
            DeleteModal
        ],
        data: function () {
            return {
                resource: 'permissions',
                pageActions: {
                    buttons: [
                        {
                            label: 'Save',
                            icon: 'save',
                            iconClass: 'text-green-600',
                            type: 'method',
                            method: 'save',
                        },
                        {
                            label: 'Cancel',
                            icon: 'times',
                            iconClass: 'text-red-600',
                            type: 'method',
                            method: 'cancel',
                        }
                    ],
                    additional: []
                },
                tabs: [
                    {
                        name: 'Details',
                        slug: 'details'
                    }
                ],
                startTab: null,
                loading: true,
                submitted: false,
                errorMessage: '',
                item: {
                    tags: []
                },
                S3URL: process.env.VUE_APP_S3_URL,
                confirm: '',
                searchPermissions: '',
                originalPermissions: [],
                selectedPermissions: [],
                permissionsLoading: true,
                searchSections: '',
                originalSections: [],
                selectedSections: [],
                sectionsLoading: true,
                options: {
                    types: []
                }
            }
        },
        methods: {
            getData: function () {
                this.$Progress.start();

                axios.get(process.env.VUE_APP_API_URL + '/permissions/' + this.id, {
                    params: {
                        with: 'type'
                    }
                }).then(response => {
                    this.item = response.data;

                    this.$Progress.finish();
                    this.loading = false;
                })
                .catch(() => {
                    this.$Progress.finish();
                    this.loading = false;
                });
            },
            // Get Data Used for Select Inputs / Other Pre-Defined Data / Relationships
            getFormData: function(){
                axios.get(process.env.VUE_APP_API_URL + '/permissions/form-data')
                    .then(response => {
                        // Types
                        this.options.types = response.data.types.map(function (type) {
                            return { label: type.name, value: type.id };
                        });
                    })
                    .catch(() => {

                    });
            },
            submitForm: function () {
                this.submitted = false;

                this.$refs.form.validate().then(success => {
                    let _method;
                    let _url;
                    if (!success) {
                        this.submitted = true;
                        return;
                    }

                    this.submitted = true;

                    this.$store.commit('TOGGLE_BACKDROP', {open: true});
                    this.errorMessage = '';

                    if (this.id) {
                        _url = process.env.VUE_APP_API_URL + '/permissions/' + this.id;
                        _method = 'PUT';
                    } else if (this.item.id) {
                        _url = process.env.VUE_APP_API_URL + '/permissions/' + this.item.id;
                        _method = 'PUT';
                    } else {
                        _url = process.env.VUE_APP_API_URL + '/permissions';
                        _method = 'POST';
                    }

                    this.item.sections = this.selectedSections;
                    this.item.permissions = this.selectedPermissions;

                    axios({
                        method: _method,
                        url: _url,
                        data: this.item
                    }).then(response => {
                        if (response.data.success) {
                            this.$store.commit('TOGGLE_BACKDROP', {open: false});

                            if (this.saveClose) {
                                if (this.return) {
                                    this.$router.push(this.return);
                                } else {
                                    this.$router.push('/configuration/permissions');
                                }
                            } else {
                                this.$router.push('/configuration/permissions');
                            }

                            this.$notify({
                                group: 'main',
                                type: 'success',
                                title: 'Success',
                                text: response.data.message,
                                duration: 5000
                            });

                        } else {
                            if (response.data.message) {
                                this.errorMessage = response.data.message;
                            }
                            this.$store.commit('TOGGLE_BACKDROP', {open: false});
                        }
                    }).catch(error => {
                        if (error.response.data.message) {
                            this.errorMessage = error.response.data.message;
                        } else {
                            this.errorMessage = 'An error occurred. Please contact the System Administrator.';
                        }

                        this.$store.commit('TOGGLE_BACKDROP', {open: false});
                    });
                });
            },
            cancel: function () {
                this.$router.push(this.return);
            },
            methodHandler: function (method) {
                this[method]();
            },
            actionHandler: function (data) {
                this[data.method](data);
            },
            getSections: function(){
                axios.get(process.env.VUE_APP_API_URL + '/sections').then(response => {
                    this.originalSections = response.data.map(function (section) {
                        return { id: section.id, name: section.name, description: section.description, level: section.level };
                    });
                    this.sectionsLoading = false;
                });
            },
            getPermissions: function(){
                axios.get(process.env.VUE_APP_API_URL + '/permissions', { params: { active: 1, standard: 0  } }).then(response => {
                    this.originalPermissions = response.data.map(function (permission) {
                        return { id: permission.id, name: permission.name, description: permission.description };
                    });
                    this.permissionsLoading = false;
                });
            }
        },
        beforeMount() {
            this.getFormData();
            this.getSections();
            this.getPermissions();
        },
        mounted() {
            if (this.type === "New") {
                this.loading = false;
                this.item.active = true;
                this.$Progress.finish();
                // Se defaults here
            } else if (this.type === "Edit") {
                this.pageActions.additional.push({
                    label: 'Delete',
                    icon: 'trash-alt',
                    type: 'method',
                    method: 'deleteModal',
                    iconClass: 'text-red-500',
                    display: !!(this.$store.getters.permissions.indexOf('permissions.destroy') !== -1 || this.$store.getters.nimdarepus)
                });
                this.getData();
            }

            const params = new URLSearchParams(window.location.search)

            let windowLocationHash = window.location.hash.replace('#', '');

            if (windowLocationHash) {
                this.startTab = windowLocationHash;
            }
        },
        computed: {
            permissions () {
                if (this.searchPermissions) {
                    return this.originalPermissions.filter(item => item.name.toUpperCase().includes(this.searchPermissions.toUpperCase()));
                }
                return this.originalPermissions;
            },
            sections () {
                if (this.searchSections) {
                    return this.originalSections.filter(item => item.name.toUpperCase().includes(this.searchSections.toUpperCase()));
                }
                return this.originalSections;
            },
            selectAllSections: {
                get: function () {
                    return this.sections ? this.selectedSections.length === this.sections.length : false;
                },
                set: function (value) {
                    let selected = [];

                    if (value) {
                        this.sections.forEach(function (section) {
                            selected.push(section.id);
                        });
                    }

                    this.selectedSections = selected;
                }
            },
            selectAllPermissions: {
                get: function () {
                    return this.permissions ? this.selectedPermissions.length === this.permissions.length : false;
                },
                set: function (value) {
                    let selected = [];

                    if (value) {
                        this.permissions.forEach(function (section) {
                            selected.push(section.id);
                        });
                    }

                    this.selectedPermissions = selected;
                }
            },
            initialValue(){
                let output = {};

                if (this.item.type){
                    output['type'] = this.item.type.id;
                } else {
                    output['type'] =  null
                }

                return output;
            }
        }
    }
</script>

<style scoped>

</style>
